import React from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import { Box, Typography, Grid } from '@mui/material';
import BoltIcon from '@mui/icons-material/Bolt';
import DomainIcon from '@mui/icons-material/Domain';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import BuildIcon from '@mui/icons-material/Build';
import PublicIcon from '@mui/icons-material/Public'; 

const HomePageDesktop = () => {
    const iconData = [
        { icon: <BoltIcon sx={{ fontSize: 60, color: '#22538bff' }} />, label: 'Energy' },
        { icon: <DomainIcon sx={{ fontSize: 60, color: '#22538bff' }} />, label: 'Infrastructure' },
        { icon: <PrecisionManufacturingIcon sx={{ fontSize: 60, color: '#22538bff' }} />, label: 'Automation' },
        { icon: <LightbulbIcon sx={{ fontSize: 60, color: '#22538bff' }} />, label: 'Innovation' },
        { icon: <BuildIcon sx={{ fontSize: 60, color: '#22538bff' }} />, label: 'Engineering' },
        { icon: <PublicIcon sx={{ fontSize: 60, color: '#22538bff' }} />, label: 'Solutions' },
    ];

    const clientLogos = [
        "divislab.png",
        "ge-td.png",
        "hyosung.png",
        "l&t.png",
        "powergrid.png",
        "sagarcement.png",
        "tgspdcl.png",
        "tgtransco.png",
    ];


    return (
        <Box sx={{ py: { xs: 6, md: 10 }, px: { xs: 3, md: 12 }, backgroundColor: '#f9f9f9' }}>

            {/* -------------------- Innovation Section -------------------- */}
            <Grid container alignItems="center" spacing={4}>
                <Grid item xs={12} md={4}>
                    <Typography
                        variant="h3"
                        sx={{ fontWeight: 700, color: '#22538bff', textAlign: { xs: 'center', md: 'left' }, mb: 2, ml: { xs: 0, md: '18px' }, }}
                    >
                        Innovation
                    </Typography>
                </Grid>
                <Grid item xs={12} md={8} sx={{ pl: { md: 30 } }}>
                    <Typography
                        sx={{
                            lineHeight: 1.8,
                            color: '#444',
                            textAlign: { xs: 'center', md: 'left' },
                            fontSize: '1.05rem',
                            maxWidth: 1200,
                            mx: { xs: 'auto', md: 0 },
                        }}
                    >
                        Innovation drives everything we do, delivering solutions that are responsible, beneficial, and viable.
                        <br />
                        Our projects positively impact communities and local society while minimizing environmental footprint.
                    </Typography>
                </Grid>
            </Grid>

            {/* -------------------- Industry Section -------------------- */}
            <Box
                sx={{
                    mt: { xs: 6, md: 10 },
                    backgroundImage: `url("homepage/solar.png")`,
                    backgroundSize: '100% 100%',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    width: '100vw',
                    minHeight: { xs: '40vh', md: '60vh' },
                    py: { xs: 6, md: 10 },
                    ml: 'calc(-50vw + 50%)',
                }}
            >
                <Grid container spacing={6} alignItems="flex-start" sx={{ px: { xs: 3, md: 12 } }}>
                    {/* Left Side - Text */}
                    <Grid item xs={12} md={6}>
                        <Typography
                            variant="h3"
                            sx={{ fontWeight: 700, color: '#22538bff', textAlign: { xs: 'center', md: 'left' }, mb: 2, ml: { xs: 0, md: '27px' }, }}
                        >
                            Industry
                        </Typography>

                        <Typography
                            sx={{
                                lineHeight: 1.8,
                                color: '#444',
                                textAlign: { xs: 'center', md: 'left' },
                                fontSize: '1.05rem',
                                maxWidth: 900,
                                overflow: 'hidden',
                                display: '-webkit-box',
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: 'vertical',
                                ml: { xs: 0, md: '27px' },
                            }}
                        >
                            Anagha Engineers, brings together technologies and expertise to address  <br />
                             the toughest power system challenges and accelerate the global<br />
                            transition to a more resilient and reliable grid.
                        </Typography>
                    </Grid>

                    {/* Right Side - Icons */}
                    <Grid item xs={12} md={6} sx={{ pl: { md: 10 } }}>
                        <Grid
                            container
                            direction="column"
                            spacing={12}
                            sx={{ alignItems: { xs: 'center', md: 'flex-end', } }}
                        >
                            {/* First Row */}
                            <Grid container spacing={14} sx={{ justifyContent: { xs: 'center', md: 'flex-end' } }}>
                                {iconData.slice(0, 3).map((item, index) => (
                                    <Grid
                                        item xs={12} sm={6} md={4}
                                        key={index}
                                        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}
                                    >
                                        <Box
                                            sx={{
                                                borderRadius: '50%',
                                                p: 2,
                                                transition: '0.3s',
                                                '&:hover': {
                                                    backgroundColor: 'rgba(34, 83, 139, 0.45)',
                                                },
                                                display: 'inline-flex',
                                            }}
                                        >
                                            {item.icon}
                                        </Box>
                                        <Typography sx={{ mt: 2, fontWeight: 500, color: '#333', fontSize: '1rem' }}>
                                            {item.label}
                                        </Typography>
                                    </Grid>
                                ))}
                            </Grid>

                            {/* Second Row */}
                            <Grid container spacing={14} sx={{ justifyContent: { xs: 'center', md: 'flex-end' } }}>
                                {iconData.slice(3, 6).map((item, index) => (
                                    <Grid
                                        item xs={12} sm={6} md={4}
                                        key={index + 3}
                                        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}
                                    >
                                        <Box
                                            sx={{
                                                borderRadius: '50%',
                                                p: 2,
                                                transition: '0.3s',
                                                '&:hover': {
                                                    backgroundColor: 'rgba(34, 83, 139, 0.45)',
                                                },
                                                display: 'inline-flex',
                                            }}
                                        >
                                            {item.icon}
                                        </Box>
                                        <Typography sx={{ mt: 2, fontWeight: 500, color: '#333', fontSize: '1rem' }}>
                                            {item.label}
                                        </Typography>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>

            {/* -------------------- Clients Section (8 Logos Moving Around Square) -------------------- */}
            <Box
                sx={{
                    py: { xs: 6, md: 10 },
                    backgroundColor: "#f9f9f9",
                    px: { xs: 3, md: 12 },
                    position: "relative",
                }}
            >
                {/* Top Left — Text */}
                <Box
                    sx={{
                        position: "absolute",
                        top: { xs: 40, md: 70 },
                        left: { xs: 22, md: 22 },
                        zIndex: 2,
                        maxWidth: 400,
                    }}
                >
                    <Typography
                        variant="h3"
                        sx={{
                            fontWeight: 700,
                            color: "#22538bff",
                            textAlign: "left",
                            mb: 2,
                        }}
                    >
                        Clients
                    </Typography>
                    <Typography
                        sx={{
                            color: "#444",
                            fontSize: "1.05rem",
                            lineHeight: 1.8,
                            maxWidth: 380,
                        }}
                    >
                        We are proud to have partnered with leading organizations across industries,
                        delivering innovative and sustainable solutions.
                    </Typography>
                </Box>

                {/* Right Side — Logos Moving Around Rectangular Path */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: { xs: "center", md: "flex-end" },
                        alignItems: "flex-start",
                        mt: { xs: 6, md: -2 },
                        pr: { xs: 0, md: 12 }, // slightly less padding on right
                    }}
                >
                    <Box
                        sx={{
                            position: "relative",
                            width: { xs: 500, md: 650 },
                            height: { xs: 350, md: 400 },
                            ml: { xs: 0, md: 18 }, // shift container to the right
                        }}
                    >
                        {clientLogos.map((logo, index) => {
                            const delay = index * 3;
                            const lower = logo.toLowerCase();

                            const isSmall =
                                lower.includes("l&t") ||
                                lower.includes("tgttransco") ||
                                lower.includes("hyosung");

                            const isLarge =
                                lower.includes("divis")
                              lower.includes("tgspdcl");

                            return (
                                <Box
                                    key={index}
                                    sx={{
                                        position: "absolute",
                                        width: { xs: 130, md: 145 },
                                        height: { xs: 140, md: 145 },
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        borderRadius: 2,
                                        backgroundColor: "#b2ebf2",
                                        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                        animation: `moveRectangle 26s linear infinite`,
                                        animationDelay: `${delay}s`,
                                        "& img": {
                                            maxWidth: isLarge ? "180%" : isSmall ? "75%" : "100%",
                                            maxHeight: isLarge ? "180%" : isSmall ? "75%" : "100%",
                                            objectFit: "contain",
                                            transition: "transform 0.3s ease",
                                            "&:hover": { transform: "scale(1.05)" },
                                        },
                                        "@keyframes moveRectangle": {
                                            "0%": { top: "5%", left: "5%" },
                                            "25%": { top: "5%", left: "95%" },
                                            "50%": { top: "95%", left: "95%" },
                                            "75%": { top: "95%", left: "5%" },
                                            "100%": { top: "5%", left: "5%" },
                                        },
                                    }}
                                >
                                    <img src={`/clientlogos/${logo}`} alt={`client-${index}`} />
                                </Box>
                            );
                        })}
                    </Box>
                </Box>

            </Box>
        </Box>
    );
};

export default HomePageDesktop;